import React from 'react'

function MTooltipPartModal(props) {
    const {
        mensaje
    } = props
    return (
        <div 
            className="modalClaro modalTooltip" 
            id="mTooltip"
        >
            <div className="modalTooltipWrap">
                <p>
                    <strong> Información:</strong>
                </p>
                {/* <h3 className="h5"> Debe Seleccionar al menos 1 </h3> */}
                <p>{mensaje ? mensaje :"Debe Seleccionar al menos 1"}</p>
                {/* <p> Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</p> */}
                {/* <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make.</p>
                <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make.</p> */}
            </div>
        </div>
    )
}
MTooltipPartModal.defaultProps = {}
MTooltipPartModal.propTypes = {}

export default MTooltipPartModal
